<!-- src\components\Sidebar_Screen8.vue -->
<template>
	<div class="view-420" :class="$attrs.class">
		<div
			v-if="sortedLessons.length"
			:class="['view-421', 'collapsible-block']"
			:style="{ top: lessonsBlockTop + 'px' }"
		>
			<view712
				@click="lessonsBlock.toggle"
				:class="[
					view712Props.className,
					'clickable-header',
					{ collapsed: !lessonsBlock.isExpanded.value },
				]"
				:teacher2Props="view712Props.teacher2Props"
			/>

			<transition
				name="collapse"
				@enter="enter"
				@after-enter="afterEnter"
				@leave="leave"
			>
				<div v-show="lessonsBlock.isExpanded.value">
					<div class="view-422">
						<template
							v-for="(lesson, index) in sortedLessons"
							:key="getLessonKey(lesson, index)"
						>
							<div
								:class="getLessonCardClassName(lesson, index, ['x3-21'])"
								@click="selectLesson(lesson, index)"
							>
								<div class="card-border-x3"></div>
								<div class="rectangle-81-40"></div>
								<img
									class="image-41"
									:src="getLessonImage(lesson)"
									alt="image"
								/>
								<div class="view-423">
									<p class="x01-38" lang="ru">
										{{ getItemTitle(lesson, '') }}
									</p>
									<img
										v-if="isLessonVideo(lesson)"
										class="vector-295"
										src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-617.svg"
										alt="Vector"
									/>
									<div
										v-else
										class="lesson-icon-article vector-295"
										aria-hidden="true"
									>
										<svg
											width="23"
											height="19"
											viewBox="0 0 23 19"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z"
												fill="white"
												fill-opacity="0.7"
											/>
										</svg>
									</div>
								</div>
								<view692 v-if="getLessonState(lesson, index) === 'completed'" />
							</div>
						</template>
					</div>
				</div>
			</transition>
		</div>

		<view722 v-bind="view722Props" />

		<div class="view-container-3">
			<div
				v-if="sortedPractice.length"
				:class="['view-425', 'collapsible-block']"
				:style="{ top: practiceBlockTop + 'px' }"
			>
				<div
					class="view-430 block-header-clickable"
					@click="practiceBlock.toggle"
					:class="{ collapsed: !practiceBlock.isExpanded.value }"
				>
					<div v-html="text396" class="text-396"></div>
					<div class="text-3-4">{{ text397 }}</div>
					<writing :class="writingProps.className" />
				</div>

				<transition
					name="collapse"
					@enter="enter"
					@after-enter="afterEnter"
					@leave="leave"
				>
					<div v-show="practiceBlock.isExpanded.value">
						<div class="view-426">
							<div
								v-for="(practice, index) in sortedPractice"
								:key="getPracticeKey(practice, index)"
								:class="
									getPracticeCardClassName(practice, index, [
										'link',
										'practice-card',
									])
								"
								@click="selectPractice(practice, index)"
							>
								<div class="card-bor-x4"></div>
								<img
									class="image-42"
									:src="getPracticeImage(practice, index)"
									alt="image"
								/>
								<div class="recT44"></div>
								<div class="view-427">
									<p class="x01-39" lang="ru">
										{{ getPracticeTitle(practice, index) }}
									</p>
								</div>
								<view692 class="practice-check-icon" />
							</div>
						</div>
					</div>
				</transition>
			</div>

			<div
				v-if="sortedTests.length"
				:class="['view-431', 'collapsible-block']"
				:style="{ top: testsBlockTop + 'px' }"
			>
				<div
					class="view-433 block-header-clickable"
					@click="testsBlock.toggle"
					:class="{ collapsed: !testsBlock.isExpanded.value }"
				>
					<div v-html="text391" class="text-391"></div>
					<div class="text-3-4">{{ text392 }}</div>
					<task :class="taskProps.className" />
				</div>

				<transition
					name="collapse"
					@enter="enter"
					@after-enter="afterEnter"
					@leave="leave"
				>
					<div v-show="testsBlock.isExpanded.value">
						<div class="view-402">
							<div
								v-for="(test, index) in sortedTests"
								:key="getTestKey(test, index)"
								:class="getTestCardClassName(test, index, ['link'])"
								@click="selectTest(test, index)"
							>
								<div class="card-bor-x5"></div>
								<img
									class="image-45"
									:src="getTestImage(test, index)"
									alt="image"
								/>
								<div class="view-432">
									<p class="x01-42" lang="ru">{{ getItemTitle(test, x018) }}</p>
									<span v-if="isFinalTest(test)" class="final-test-badge">
										Финальный тест
									</span>
									<img
										class="vector-301"
										src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-602.svg"
										alt="Vector"
									/>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>

			<div
				v-if="sortedHomework.length"
				:class="['view-434', 'collapsible-block']"
				:style="{ top: homeworkBlockTop + 'px' }"
			>
				<div
					class="view-436 block-header-clickable"
					@click="homeworkBlock.toggle"
					:class="{ collapsed: !homeworkBlock.isExpanded.value }"
				>
					<div v-html="text386" class="text-386"></div>
					<div class="text-3-4">{{ text387 }}</div>
					<drawing :class="drawingProps.className" />
				</div>

				<transition
					name="collapse"
					@enter="enter"
					@after-enter="afterEnter"
					@leave="leave"
				>
					<div v-show="homeworkBlock.isExpanded.value">
						<div class="view-402-1">
							<div
								v-for="(homework, index) in sortedHomework"
								:key="getHomeworkKey(homework, index)"
								:class="getHomeworkCardClassName(homework, index, ['link'])"
								@click="selectHomework(homework, index)"
							>
								<div class="card-bor-x6"></div>
								<img
									class="image-46"
									:src="getHomeworkImage(homework, index)"
									alt="image"
								/>
								<div class="view-427 homework-card-content">
									<div v-html="getHomeworkIcon(index)" class="text-395"></div>
									<p class="x01-39 homework-card-title" lang="ru">
										{{ getItemTitle(homework, x019) }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { useCollapsible } from '../composables/useCollapsible'
import { BLOCK_DIMENSIONS } from '@/constants/layout'
import View702 from './View702'
import View712 from './View712'
import View722 from './View722'
import X533 from './X533'
import X6 from './X6'
import View692 from './View692'
import Writing from './Writing'
import X282 from './X282'
import Task from './Task'
import Drawing from './Drawing'

export default {
	name: 'Sidebar_Screen8',
	inheritAttrs: false,
	components: {
		View702,
		View712,
		View722,
		X533,
		X6,
		View692,
		Writing,
		X282,
		Task,
		Drawing,
	},
	props: {
		lessons: {
			type: Array,
			default: () => [],
		},
		practice: {
			type: Array,
			default: () => [],
		},
		tests: {
			type: Array,
			default: () => [],
		},
		finalTestId: {
			type: [String, Number],
			default: null,
		},
		homework: {
			type: Array,
			default: () => [],
		},
		contentMode: {
			type: String,
			default: 'video',
		},
		selectedLessonKey: {
			type: [String, Number],
			default: null,
		},
		selectedPracticeKey: {
			type: [String, Number],
			default: null,
		},
		selectedTestKey: {
			type: [String, Number],
			default: null,
		},
		selectedHomeworkKey: {
			type: [String, Number],
			default: null,
		},
		image1: String,
		image2: String,
		text409: String,
		x012: String,
		x013: String,
		x014: String,
		image3: String,
		text395: String,
		x015: String,
		image4: String,
		text394: String,
		x016: String,
		image5: String,
		text393: String,
		x017: String,
		text396: String,
		text397: String,
		image6: String,
		text390: String,
		x018: String,
		text391: String,
		text392: String,
		image7: String,
		text385: String,
		x019: String,
		image8: String,
		text384: String,
		x0110: String,
		image9: String,
		text383: String,
		x0111: String,
		text386: String,
		text387: String,
		view702Props: {
			type: Object,
			default: () => ({}),
		},
		view712Props: {
			type: Object,
			default: () => ({}),
		},
		view722Props: {
			type: Object,
			default: () => ({}),
		},
		x1152Props: {
			type: Object,
			default: () => ({}),
		},
		x272Props: {
			type: Object,
			default: () => ({}),
		},
		x5331Props: {
			type: Object,
			default: () => ({}),
		},
		x61Props: {
			type: Object,
			default: () => ({}),
		},
		x5332Props: {
			type: Object,
			default: () => ({}),
		},
		x62Props: {
			type: Object,
			default: () => ({}),
		},
		x63Props: {
			type: Object,
			default: () => ({}),
		},
		x5333Props: {
			type: Object,
			default: () => ({}),
		},
		writingProps: {
			type: Object,
			default: () => ({}),
		},
		x2821Props: {
			type: Object,
			default: () => ({}),
		},
		x2822Props: {
			type: Object,
			default: () => ({}),
		},
		taskProps: {
			type: Object,
			default: () => ({}),
		},
		drawingProps: {
			type: Object,
			default: () => ({}),
		},
	},
	emits: [
		'update:contentMode',
		'update:sidebarHeight',
		'update:selectedLessonKey',
		'update:selectedPracticeKey',
		'update:selectedTestKey',
		'update:selectedHomeworkKey',
	],
	setup(props, { emit }) {
		const lessonsBlock = useCollapsible(true)
		const practiceBlock = useCollapsible(true)
		const testsBlock = useCollapsible(true)
		const homeworkBlock = useCollapsible(true)

		const contentMode = computed({
			get: () => props.contentMode,
			set: value => emit('update:contentMode', value),
		})

		const moduleLessons = computed(() => props.lessons || [])
		const modulePractice = computed(() => props.practice || [])
		const moduleTests = computed(() => props.tests || [])
		const moduleHomework = computed(() => props.homework || [])

		const getItemTitle = (item, fallback = '') =>
			item?.title || item?.name || fallback

		const normalizeBoolean = value => {
			if (value === null || value === undefined) return null
			if (typeof value === 'boolean') return value
			if (typeof value === 'number') return value !== 0
			if (typeof value === 'string') {
				const normalized = value.trim().toLowerCase()
				if (['true', '1', 'yes', 'y', 'да'].includes(normalized)) return true
				if (['false', '0', 'no', 'n', 'нет'].includes(normalized)) return false
			}
			return Boolean(value)
		}

		const getLessonKey = (lesson, index) =>
			lesson?.id ?? lesson?._id ?? lesson?.lesson_id ?? index

		const getLessonType = lesson =>
			lesson?.lesson_type ||
			lesson?.type ||
			(lesson?.video_url || lesson?.videoUrl || lesson?.video_file_url
				? 'video'
				: 'article')

		const isLessonCompleted = lesson => {
			if (!lesson) return false
			if (lesson?.is_completed !== undefined)
				return normalizeBoolean(lesson.is_completed) === true
			if (lesson?.isCompleted !== undefined)
				return normalizeBoolean(lesson.isCompleted) === true
			if (lesson?.completed !== undefined)
				return normalizeBoolean(lesson.completed) === true
			if (lesson?.status) return lesson.status === 'completed'
			return false
		}

		const isLessonVideo = lesson => getLessonType(lesson) === 'video'
		const isLessonArticle = lesson => getLessonType(lesson) === 'article'

		const getLessonOrder = lesson =>
			lesson?.order ??
			lesson?.order_number ??
			lesson?.position ??
			lesson?.sort_order ??
			lesson?.sortOrder ??
			lesson?.index ??
			null

		const sortedLessons = computed(() => {
			const lessons = moduleLessons.value.slice()
			const hasOrder = lessons.some(
				item =>
					getLessonOrder(item) !== null && getLessonOrder(item) !== undefined,
			)
			if (!hasOrder) return lessons
			return lessons.sort((a, b) => {
				const orderA = getLessonOrder(a) ?? 0
				const orderB = getLessonOrder(b) ?? 0
				return orderA - orderB
			})
		})

		const firstIncompleteIndex = computed(() =>
			sortedLessons.value.findIndex(lesson => !isLessonCompleted(lesson)),
		)

		const selectedLessonKey = computed({
			get: () => props.selectedLessonKey,
			set: value => emit('update:selectedLessonKey', value),
		})
		const _selectedLesson = computed(() => {
			if (!sortedLessons.value.length) return null
			const found = sortedLessons.value.find(
				(lesson, index) =>
					getLessonKey(lesson, index) === selectedLessonKey.value,
			)
			return found || sortedLessons.value[0]
		})

		const isLessonSelected = (lesson, index) => {
			if (contentMode.value !== 'video' && contentMode.value !== 'article') {
				return false
			}
			return getLessonKey(lesson, index) === selectedLessonKey.value
		}

		const getLessonImage = lesson =>
			lesson?.cover_image ||
			lesson?.cover_image_url ||
			lesson?.preview_image ||
			lesson?.image ||
			props.image2 ||
			props.image1

		const getLessonState = (lesson, index) => {
			if (isLessonCompleted(lesson)) return 'completed'
			if (firstIncompleteIndex.value === -1) return 'completed'
			if (index === firstIncompleteIndex.value) return 'current'
			if (index > firstIncompleteIndex.value) return 'locked'
			return 'available'
		}

		const isLessonLocked = (lesson, index) =>
			getLessonState(lesson, index) === 'locked'

		const getLessonCardClassName = (lesson, index, baseClasses = []) => {
			const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses]
			const state = getLessonState(lesson, index)
			if (state === 'completed') {
				classes.push('lesson-card-completed')
			} else if (state === 'current') {
				classes.push('lesson-card-active')
			} else if (state === 'locked') {
				classes.push('lesson-card-inactive', 'lesson-card-locked')
			} else {
				classes.push('lesson-card-inactive')
			}
			if (isLessonSelected(lesson, index)) {
				classes.push('lesson-card-selected')
			}
			return classes.filter(Boolean).join(' ')
		}

		const getPracticeKey = (item, index) =>
			item?.id ?? item?._id ?? item?.task_id ?? item?.practical_id ?? index

		const getPracticeOrder = item =>
			item?.order ??
			item?.order_number ??
			item?.position ??
			item?.sort_order ??
			item?.sortOrder ??
			item?.index ??
			null

		const sortedPractice = computed(() => {
			const items = modulePractice.value.slice()
			const hasOrder = items.some(
				item =>
					getPracticeOrder(item) !== null &&
					getPracticeOrder(item) !== undefined,
			)
			if (!hasOrder) return items
			return items.sort((a, b) => {
				const orderA = getPracticeOrder(a) ?? 0
				const orderB = getPracticeOrder(b) ?? 0
				return orderA - orderB
			})
		})

		const isPracticeCompleted = item => {
			if (!item) return false
			if (item?.is_completed !== undefined)
				return normalizeBoolean(item.is_completed) === true
			if (item?.isCompleted !== undefined)
				return normalizeBoolean(item.isCompleted) === true
			if (item?.completed !== undefined)
				return normalizeBoolean(item.completed) === true
			const status =
				item?.submission_status ??
				item?.submissionStatus ??
				item?.status ??
				null
			if (status) return ['completed', 'verified'].includes(status)
			const completionPercent =
				item?.completion_percent ??
				item?.completionPercent ??
				item?.progress_percent ??
				item?.progressPercent ??
				null
			if (completionPercent !== undefined && completionPercent !== null) {
				return Number(completionPercent) >= 100
			}
			return false
		}

		const firstIncompletePracticeIndex = computed(() =>
			sortedPractice.value.findIndex(item => !isPracticeCompleted(item)),
		)

		const getPracticeState = (item, index) => {
			if (isPracticeCompleted(item)) return 'completed'
			if (firstIncompletePracticeIndex.value === -1) return 'completed'
			if (index === firstIncompletePracticeIndex.value) return 'current'
			if (index > firstIncompletePracticeIndex.value) return 'locked'
			return 'available'
		}

		const isPracticeLocked = (item, index) =>
			getPracticeState(item, index) === 'locked'

		const selectedPracticeKey = computed({
			get: () => props.selectedPracticeKey,
			set: value => emit('update:selectedPracticeKey', value),
		})

		const isPracticeSelected = (item, index) => {
			if (contentMode.value !== 'practice') {
				return false
			}
			return getPracticeKey(item, index) === selectedPracticeKey.value
		}

		const getPracticeCardClassName = (item, index, baseClasses = []) => {
			const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses]
			const state = getPracticeState(item, index)
			if (state === 'completed') {
				classes.push('practice-card-completed')
			} else if (state === 'current') {
				classes.push('lesson-card-active')
			} else {
				classes.push('lesson-card-inactive')
			}
			if (isPracticeSelected(item, index)) {
				classes.push('lesson-card-selected')
			}
			if (isPracticeLocked(item, index)) {
				classes.push('lesson-card-locked')
			}
			return classes.filter(Boolean).join(' ')
		}

		const practiceFallbackImages = computed(() =>
			[props.image3, props.image4, props.image5].filter(Boolean),
		)

		const getPracticeImage = (item, index) =>
			item?.cover_image ||
			item?.cover_image_url ||
			item?.preview_image ||
			item?.image ||
			practiceFallbackImages.value[index] ||
			practiceFallbackImages.value[0] ||
			props.image3 ||
			props.image4 ||
			props.image5

		const getPracticeTitle = (item, index) => {
			const fallback = [props.x015, props.x016, props.x017][index] || ''
			return getItemTitle(item, fallback)
		}

		const _selectedPractice = computed(() => {
			if (!sortedPractice.value.length) return null
			const found = sortedPractice.value.find(
				(item, index) =>
					getPracticeKey(item, index) === selectedPracticeKey.value,
			)
			return found || sortedPractice.value[0]
		})

		const getTestKey = (test, index) =>
			test?.id ?? test?._id ?? test?.test_id ?? test?.testId ?? index

		const getTestId = test =>
			test?.id ?? test?._id ?? test?.test_id ?? test?.testId ?? null

		const isFinalTest = test => {
			if (!props.finalTestId) return false
			const id = getTestId(test)
			return id !== null && String(id) === String(props.finalTestId)
		}

		const getTestOrder = test =>
			test?.order ??
			test?.order_number ??
			test?.position ??
			test?.sort_order ??
			test?.sortOrder ??
			test?.index ??
			null

		const getTestCreatedAtValue = test => {
			const raw =
				test?.created_at ??
				test?.createdAt ??
				test?.created ??
				test?.created_date ??
				test?.createdDate ??
				null
			if (!raw) return null
			const value = new Date(raw).getTime()
			return Number.isNaN(value) ? null : value
		}

		const sortedTests = computed(() => {
			const items = moduleTests.value.map((item, index) => ({ item, index }))
			const hasOrder = items.some(
				entry =>
					getTestOrder(entry.item) !== null &&
					getTestOrder(entry.item) !== undefined,
			)
			const hasCreatedAt = items.some(
				entry => getTestCreatedAtValue(entry.item) !== null,
			)
			if (!hasOrder && !hasCreatedAt) return items.map(entry => entry.item)
			return items
				.sort((a, b) => {
					if (hasOrder) {
						const orderA = getTestOrder(a.item)
						const orderB = getTestOrder(b.item)
						const normalizedA =
							orderA !== null && orderA !== undefined
								? orderA
								: Number.POSITIVE_INFINITY
						const normalizedB =
							orderB !== null && orderB !== undefined
								? orderB
								: Number.POSITIVE_INFINITY
						if (normalizedA !== normalizedB) return normalizedA - normalizedB
					}
					if (hasCreatedAt) {
						const dateA = getTestCreatedAtValue(a.item)
						const dateB = getTestCreatedAtValue(b.item)
						const normalizedA =
							dateA !== null && dateA !== undefined
								? dateA
								: Number.POSITIVE_INFINITY
						const normalizedB =
							dateB !== null && dateB !== undefined
								? dateB
								: Number.POSITIVE_INFINITY
						if (normalizedA !== normalizedB) return normalizedA - normalizedB
					}
					return a.index - b.index
				})
				.map(entry => entry.item)
		})

		const isTestCompleted = test => {
			if (!test) return false
			if (test?.is_completed !== undefined)
				return normalizeBoolean(test.is_completed) === true
			if (test?.isCompleted !== undefined)
				return normalizeBoolean(test.isCompleted) === true
			if (test?.completed !== undefined)
				return normalizeBoolean(test.completed) === true
			if (test?.passed !== undefined)
				return normalizeBoolean(test.passed) === true
			if (test?.status) return test.status === 'completed'
			if (test?.completion_percent !== undefined) {
				return Number(test.completion_percent) >= 100
			}
			return false
		}

		const selectedTestKey = computed({
			get: () => props.selectedTestKey,
			set: value => emit('update:selectedTestKey', value),
		})
		const _selectedTest = computed(() => {
			if (!sortedTests.value.length) return null
			const found = sortedTests.value.find(
				(test, index) => getTestKey(test, index) === selectedTestKey.value,
			)
			return found || sortedTests.value[0]
		})

		const isTestSelected = (test, index) =>
			contentMode.value === 'test' &&
			getTestKey(test, index) === selectedTestKey.value

		const testFallbackImages = computed(() => [props.image6].filter(Boolean))

		const getTestImage = test =>
			test?.cover_image ||
			test?.cover_image_url ||
			test?.preview_image ||
			test?.image ||
			testFallbackImages.value[0] ||
			props.image6

		// Определяем первый незавершённый тест для логики блокировки
		const firstIncompleteTestIndex = computed(() =>
			sortedTests.value.findIndex(test => !isTestCompleted(test)),
		)

		const getTestState = (test, index) => {
			if (isTestCompleted(test)) return 'completed'
			if (firstIncompleteTestIndex.value === -1) return 'completed'
			if (index === firstIncompleteTestIndex.value) return 'current'
			return 'available'
		}

		const _isTestLocked = () => false

		const getTestCardClassName = (test, index, baseClasses = []) => {
			const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses]
			classes.push('test-card')
			const state = getTestState(test, index)
			if (state === 'completed') {
				classes.push('test-card-completed')
			} else {
				classes.push('test-card-active')
			}
			if (isTestSelected(test, index)) {
				classes.push('test-card-selected')
			}
			return classes.filter(Boolean).join(' ')
		}

		const getHomeworkKey = (item, index) =>
			item?.id ??
			item?._id ??
			item?.homework_id ??
			item?.homeworkId ??
			item?.task_id ??
			index

		const getHomeworkOrder = item =>
			item?.order ??
			item?.order_number ??
			item?.position ??
			item?.sort_order ??
			item?.sortOrder ??
			item?.index ??
			null

		const sortedHomework = computed(() => {
			const items = moduleHomework.value.slice()
			const hasOrder = items.some(
				item =>
					getHomeworkOrder(item) !== null &&
					getHomeworkOrder(item) !== undefined,
			)
			if (!hasOrder) return items
			return items.sort((a, b) => {
				const orderA = getHomeworkOrder(a) ?? 0
				const orderB = getHomeworkOrder(b) ?? 0
				return orderA - orderB
			})
		})

		const getHomeworkSubmissionStatus = item =>
			item?.submission_status ?? item?.submissionStatus ?? item?.status ?? null

		const isHomeworkCompleted = item => {
			if (!item) return false
			if (item?.is_completed !== undefined)
				return normalizeBoolean(item.is_completed) === true
			if (item?.isCompleted !== undefined)
				return normalizeBoolean(item.isCompleted) === true
			if (item?.completed !== undefined)
				return normalizeBoolean(item.completed) === true
			const status = getHomeworkSubmissionStatus(item)
			if (status) return ['completed', 'graded', 'reviewed'].includes(status)
			if (item?.completion_percent !== undefined) {
				return Number(item.completion_percent) >= 100
			}
			return false
		}

		const selectedHomeworkKey = computed({
			get: () => props.selectedHomeworkKey,
			set: value => emit('update:selectedHomeworkKey', value),
		})
		const _selectedHomework = computed(() => {
			if (!sortedHomework.value.length) return null
			const found = sortedHomework.value.find(
				(item, index) =>
					getHomeworkKey(item, index) === selectedHomeworkKey.value,
			)
			return found || sortedHomework.value[0]
		})

		const isHomeworkSelected = (item, index) =>
			contentMode.value === 'homework' &&
			getHomeworkKey(item, index) === selectedHomeworkKey.value

		const homeworkIcons = computed(() =>
			[props.text385, props.text384, props.text383].filter(Boolean),
		)

		const getHomeworkIcon = index =>
			homeworkIcons.value[index] ||
			props.text385 ||
			props.text384 ||
			props.text383 ||
			''

		const homeworkFallbackImages = computed(() =>
			[props.image7, props.image8, props.image9].filter(Boolean),
		)

		const getHomeworkImage = (item, index) =>
			item?.cover_image ||
			item?.cover_image_url ||
			item?.preview_image ||
			item?.image ||
			homeworkFallbackImages.value[index] ||
			homeworkFallbackImages.value[0] ||
			props.image7 ||
			props.image8 ||
			props.image9

		// Проверка отправки ДЗ (submitted или completed)
		const isHomeworkSubmitted = item => {
			if (!item) return false
			if (
				item?.is_submitted !== undefined ||
				item?.is_completed !== undefined
			) {
				return (
					normalizeBoolean(item.is_submitted) === true ||
					normalizeBoolean(item.is_completed) === true
				)
			}
			if (item?.isSubmitted !== undefined)
				return normalizeBoolean(item.isSubmitted) === true
			if (item?.submitted !== undefined)
				return normalizeBoolean(item.submitted) === true
			const status = getHomeworkSubmissionStatus(item)
			if (status)
				return [
					'submitted',
					'completed',
					'graded',
					'reviewed',
					'needs_revision',
				].includes(status)
			return isHomeworkCompleted(item)
		}

		const parseDateInput = value => {
			if (!value) return null
			if (value instanceof Date && !Number.isNaN(value.getTime())) return value
			if (typeof value === 'number') {
				const asDate = new Date(value)
				return Number.isNaN(asDate.getTime()) ? null : asDate
			}
			const raw = String(value).trim()
			if (!raw) return null
			const dotMatch = raw.match(/^(\d{2})\.(\d{2})\.(\d{2,4})/)
			if (dotMatch) {
				let year = Number(dotMatch[3])
				if (dotMatch[3].length === 2) {
					year += 2000
				}
				return new Date(year, Number(dotMatch[2]) - 1, Number(dotMatch[1]))
			}
			const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
			if (isoMatch) {
				return new Date(
					Number(isoMatch[1]),
					Number(isoMatch[2]) - 1,
					Number(isoMatch[3]),
				)
			}
			const asDate = new Date(raw)
			return Number.isNaN(asDate.getTime()) ? null : asDate
		}

		const parseTimeInput = value => {
			if (value instanceof Date && !Number.isNaN(value.getTime())) {
				return {
					hours: value.getHours(),
					minutes: value.getMinutes(),
					seconds: value.getSeconds(),
				}
			}
			if (value === null || value === undefined) return null
			const raw = String(value).trim()
			if (!raw) return null
			const match = raw.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/)
			if (!match) return null
			return {
				hours: Number(match[1]),
				minutes: Number(match[2]),
				seconds: match[3] ? Number(match[3]) : 0,
			}
		}

		const mergeDateTime = (dateValue, timeValue) => {
			const date = parseDateInput(dateValue)
			if (!date) return null
			let time = parseTimeInput(timeValue)
			if (!time && typeof dateValue === 'string') {
				time = parseTimeInput(dateValue)
			}
			if (time) {
				date.setHours(time.hours, time.minutes, time.seconds || 0, 0)
			}
			return date
		}

		const getHomeworkDueAt = item => {
			if (!item) return null
			return mergeDateTime(
				item?.due_date ??
					item?.dueDate ??
					item?.deadline ??
					item?.due_at ??
					item?.dueAt ??
					null,
				item?.due_time ?? item?.dueTime ?? null,
			)
		}

		const getHomeworkAllowLate = item => {
			if (!item) return null
			const raw =
				item?.allow_late_submission ??
				item?.allowLate ??
				item?.allowLateSubmission ??
				item?.allow_late ??
				item?.late_allowed ??
				item?.lateAllowed ??
				null
			if (raw === null || raw === undefined) return null
			return normalizeBoolean(raw)
		}

		const isHomeworkLate = item => {
			if (!item) return false
			if (isHomeworkCompleted(item) || isHomeworkSubmitted(item)) return false
			const dueAt = getHomeworkDueAt(item)
			if (!dueAt) return false
			const allowLate = getHomeworkAllowLate(item)
			if (allowLate !== false) return false
			return Date.now() > dueAt.getTime()
		}

		// Определяем первое неотправленное ДЗ для логики блокировки
		const firstIncompleteHomeworkIndex = computed(() =>
			sortedHomework.value.findIndex(
				item =>
					!isHomeworkSubmitted(item) &&
					!isHomeworkCompleted(item) &&
					!isHomeworkLate(item),
			),
		)

		const getHomeworkState = (item, index) => {
			if (isHomeworkCompleted(item)) return 'completed'
			if (isHomeworkSubmitted(item)) return 'submitted'
			if (isHomeworkLate(item)) return 'late'
			if (firstIncompleteHomeworkIndex.value === -1) return 'completed'
			if (index === firstIncompleteHomeworkIndex.value) return 'current'
			if (index > firstIncompleteHomeworkIndex.value) return 'locked'
			return 'available'
		}

		const isHomeworkLocked = (item, index) =>
			getHomeworkState(item, index) === 'locked'

		const getHomeworkCardClassName = (item, index, baseClasses = []) => {
			const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses]
			classes.push('homework-card')
			const state = getHomeworkState(item, index)
			if (state === 'completed') {
				classes.push('homework-card-completed')
			} else if (state === 'submitted') {
				classes.push('homework-card-submitted')
			} else if (state === 'late') {
				classes.push('homework-card-late')
			} else if (state === 'current') {
				classes.push('homework-card-active')
			} else {
				classes.push('homework-card-inactive')
			}
			if (isHomeworkSelected(item, index)) {
				classes.push('homework-card-selected')
			}
			if (isHomeworkLocked(item, index)) {
				classes.push('homework-card-locked')
			}
			return classes.filter(Boolean).join(' ')
		}

		const lessonsExpandedHeight = computed(() => {
			const count = sortedLessons.value.length || 1
			return (
				BLOCK_DIMENSIONS.LESSONS_BLOCK.HEADER_HEIGHT +
				BLOCK_DIMENSIONS.LESSONS_BLOCK.EXTRA_PADDING +
				count * BLOCK_DIMENSIONS.LESSON_CARD.HEIGHT +
				Math.max(0, count - 1) * BLOCK_DIMENSIONS.LESSON_CARD.GAP
			)
		})

		const practiceExpandedHeight = computed(() => {
			const count = sortedPractice.value.length || 3
			return (
				BLOCK_DIMENSIONS.PRACTICE_BLOCK.HEADER_HEIGHT +
				BLOCK_DIMENSIONS.PRACTICE_BLOCK.EXTRA_PADDING +
				count * BLOCK_DIMENSIONS.PRACTICE_CARD.HEIGHT +
				Math.max(0, count - 1) * BLOCK_DIMENSIONS.PRACTICE_CARD.GAP
			)
		})

		const testsExpandedHeight = computed(() => {
			const count = sortedTests.value.length || 1
			return (
				BLOCK_DIMENSIONS.TESTS_BLOCK.HEADER_HEIGHT +
				BLOCK_DIMENSIONS.TESTS_BLOCK.EXTRA_PADDING +
				count * BLOCK_DIMENSIONS.TESTS_CARD.HEIGHT +
				Math.max(0, count - 1) * BLOCK_DIMENSIONS.TESTS_CARD.GAP
			)
		})

		const homeworkExpandedHeight = computed(() => {
			const count = sortedHomework.value.length || 1
			return (
				BLOCK_DIMENSIONS.HOMEWORK_BLOCK.HEADER_HEIGHT +
				BLOCK_DIMENSIONS.HOMEWORK_BLOCK.EXTRA_PADDING +
				count * BLOCK_DIMENSIONS.HOMEWORK_CARD.HEIGHT +
				Math.max(0, count - 1) * BLOCK_DIMENSIONS.HOMEWORK_CARD.GAP
			)
		})

		const hasLessons = computed(() => sortedLessons.value.length > 0)
		const hasPractice = computed(() => sortedPractice.value.length > 0)
		const hasTests = computed(() => sortedTests.value.length > 0)
		const hasHomework = computed(() => sortedHomework.value.length > 0)

		const lessonsBlockTop = computed(() => BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP)

		const lessonsBlockHeight = computed(() => {
			if (!hasLessons.value) return 0
			return lessonsBlock.isExpanded.value
				? lessonsExpandedHeight.value
				: BLOCK_DIMENSIONS.LESSONS_BLOCK.COLLAPSED_HEIGHT
		})

		const practiceBlockHeight = computed(() => {
			if (!hasPractice.value) return 0
			return practiceBlock.isExpanded.value
				? practiceExpandedHeight.value
				: BLOCK_DIMENSIONS.PRACTICE_BLOCK.COLLAPSED_HEIGHT
		})

		const testsBlockHeight = computed(() => {
			if (!hasTests.value) return 0
			return testsBlock.isExpanded.value
				? testsExpandedHeight.value
				: BLOCK_DIMENSIONS.TESTS_BLOCK.COLLAPSED_HEIGHT
		})

		const homeworkBlockHeight = computed(() => {
			if (!hasHomework.value) return 0
			return homeworkBlock.isExpanded.value
				? homeworkExpandedHeight.value
				: BLOCK_DIMENSIONS.HOMEWORK_BLOCK.COLLAPSED_HEIGHT
		})

		const practiceBlockTop = computed(() => {
			return (
				BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP +
				lessonsBlockHeight.value +
				(hasLessons.value && hasPractice.value
					? BLOCK_DIMENSIONS.MARGINS.PRACTICE
					: 0)
			)
		})

		const testsBlockTop = computed(() => {
			if (!hasPractice.value) {
				return (
					BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP +
					lessonsBlockHeight.value +
					(hasTests.value ? BLOCK_DIMENSIONS.MARGINS.TESTS : 0)
				)
			}
			return (
				practiceBlockTop.value +
				practiceBlockHeight.value +
				(hasTests.value ? BLOCK_DIMENSIONS.MARGINS.TESTS : 0)
			)
		})

		const homeworkBlockTop = computed(() => {
			// Когда в сайдбаре остался только блок ДЗ, опускаем его ниже кнопки "Вернуться назад".
			if (
				hasHomework.value &&
				!hasLessons.value &&
				!hasPractice.value &&
				!hasTests.value
			) {
				return 65
			}

			if (!hasTests.value) {
				if (hasPractice.value) {
					return (
						practiceBlockTop.value +
						practiceBlockHeight.value +
						(hasHomework.value ? BLOCK_DIMENSIONS.MARGINS.HOMEWORK : 0)
					)
				}
				return (
					BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP +
					lessonsBlockHeight.value +
					(hasHomework.value ? BLOCK_DIMENSIONS.MARGINS.HOMEWORK : 0)
				)
			}
			return (
				testsBlockTop.value +
				testsBlockHeight.value +
				(hasHomework.value ? BLOCK_DIMENSIONS.MARGINS.HOMEWORK : 0)
			)
		})

		const sidebarHeight = computed(() => {
			if (hasHomework.value) return homeworkBlockTop.value + homeworkBlockHeight.value + 40
			if (hasTests.value) return testsBlockTop.value + testsBlockHeight.value + 40
			if (hasPractice.value) return practiceBlockTop.value + practiceBlockHeight.value + 40
			if (hasLessons.value) return lessonsBlockTop.value + lessonsBlockHeight.value + 40
			return BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP + 40
		})

		watch(
			sidebarHeight,
			value => {
				emit('update:sidebarHeight', value)
			},
			{ immediate: true },
		)

		const enter = element => {
			element.style.height = '0'
			element.style.opacity = '0'
			element.offsetHeight
			const contentHeight = element.scrollHeight
			element.style.height = `${contentHeight}px`
			element.style.opacity = '1'
		}

		const afterEnter = element => {
			element.style.height = 'auto'
		}

		const leave = element => {
			element.style.height = `${element.scrollHeight}px`
			element.offsetHeight
			element.style.height = '0'
			element.style.opacity = '0'
		}

		const selectedLessonCard = ref('card3')

		const lessonCard1Title = computed(() => props.x012 || props.x013 || '')
		const lessonCard2Title = computed(() => props.x013 || props.x012 || '')
		const lessonCard1DurationText = computed(
			() => props.text409 || props.text390 || '',
		)
		const lessonCard2DurationText = computed(
			() => props.text409 || props.text390 || '',
		)

		const selectLesson = (lesson, index) => {
			if (isLessonLocked(lesson, index)) return
			selectedLessonKey.value = getLessonKey(lesson, index)
			contentMode.value = isLessonArticle(lesson) ? 'article' : 'video'
		}

		const selectPractice = (item, index) => {
			if (isPracticeLocked(item, index)) return
			selectedPracticeKey.value = getPracticeKey(item, index)
			contentMode.value = 'practice'
		}

		const selectTest = (test, index) => {
			selectedTestKey.value = getTestKey(test, index)
			contentMode.value = 'test'
		}

		const selectHomework = (item, index) => {
			if (isHomeworkLocked(item, index)) return
			selectedHomeworkKey.value = getHomeworkKey(item, index)
			contentMode.value = 'homework'
		}

		const selectCard = cardId => {
			selectedLessonCard.value = cardId
			if (cardId === 'card3') {
				contentMode.value = 'video'
			}
		}

		const switchToTestContent = () => {
			contentMode.value = 'test'
		}

		const switchToHomeworkContent = () => {
			contentMode.value = 'homework'
		}

		return {
			lessonsBlock,
			practiceBlock,
			testsBlock,
			homeworkBlock,
			lessonsBlockTop,
			practiceBlockTop,
			testsBlockTop,
			homeworkBlockTop,
			sortedLessons,
			sortedPractice,
			sortedTests,
			sortedHomework,
			selectedLessonCard,
			lessonCard1Title,
			lessonCard2Title,
			lessonCard1DurationText,
			lessonCard2DurationText,
			getLessonKey,
			getLessonState,
			isLessonSelected,
			isLessonVideo,
			isLessonArticle,
			getLessonCardClassName,
			getLessonImage,
			getItemTitle,
			getPracticeKey,
			getPracticeCardClassName,
			getPracticeImage,
			getPracticeTitle,
			getTestKey,
			isFinalTest,
			getTestCardClassName,
			getTestImage,
			getHomeworkKey,
			getHomeworkCardClassName,
			getHomeworkImage,
			getHomeworkIcon,
			selectLesson,
			selectPractice,
			selectTest,
			selectHomework,
			selectCard,
			switchToTestContent,
			switchToHomeworkContent,
			enter,
			afterEnter,
			leave,
		}
	},
}
</script>

<style>
.view-420 {
	background-color: var(--white);
	display: flex;
	flex-direction: column;
	height: var(--sidebar-height);
	left: var(--sidebar-left-offset, 0px);
	position: absolute;
	top: var(--header-height);
	width: var(--sidebar-left-width);
	min-width: var(--sidebar-left-width);
	z-index: var(--z-sidebar);
}

.view-421 {
	height: 1053px;
	margin-left: 21px;
	position: absolute;
	width: 309px;
	transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-422 {
	display: flex;
	flex-direction: column;
	gap: 12px;
	height: auto;
	left: 0;
	position: absolute;
	top: 45px;
	width: 309px;
}

.view-422 .x1-11,
.view-422 .x2-6,
.view-422 .x3-21,
.view-422 .x4-6,
.view-422 .x533,
.view-422 .x6 {
	margin-top: 0;
}

/* Карточка урока - адаптировано из нового шаблона */
.x3-21 {
	height: 90px;
	margin-top: 8px;
	position: relative;
	width: 300px;
}

.x1-11,
.x2-6,
.x3-21,
.practice-card,
.test-card,
.homework-card {
	--card-outline-color: transparent;
	--card-outline-width: 0px;
	box-shadow: 0 0 0 var(--card-outline-width) var(--card-outline-color);
}

.x1-11.lesson-card-selected,
.x2-6.lesson-card-selected,
.x3-21.lesson-card-selected {
	--card-outline-color: #4b4b4b;
	--card-outline-width: 8px;
}

.x3-21.lesson-card-active.lesson-card-selected {
	--card-outline-color: #0274b6;
}

.x3-21.lesson-card-completed.lesson-card-selected {
	--card-outline-color: #4b4b4b;
}

.x1-11.lesson-card-inactive:not(.lesson-card-selected):hover,
.x2-6.lesson-card-inactive:not(.lesson-card-selected):hover,
.x3-21.lesson-card-inactive:not(.lesson-card-selected):hover,
.x1-11.lesson-card-completed:not(.lesson-card-selected):hover,
.x2-6.lesson-card-completed:not(.lesson-card-selected):hover,
.x3-21.lesson-card-completed:not(.lesson-card-selected):hover {
	--card-outline-color: rgba(75, 75, 75, 0.5);
	--card-outline-width: 8px;
}

.x1-11.lesson-card-active:not(.lesson-card-selected):hover,
.x2-6.lesson-card-active:not(.lesson-card-selected):hover,
.x3-21.lesson-card-active:not(.lesson-card-selected):hover {
	--card-outline-color: rgba(0, 149, 236, 0.4);
	--card-outline-width: 8px;
}

.practice-card.practice-card-completed.lesson-card-selected {
	--card-outline-color: #4b4b4b;
	--card-outline-width: 8px;
}

.practice-card.lesson-card-active.lesson-card-selected {
	--card-outline-color: #0274b6;
	--card-outline-width: 8px;
}

.practice-card.practice-card-completed:not(.lesson-card-selected):hover {
	--card-outline-color: rgba(75, 75, 75, 0.5);
	--card-outline-width: 8px;
}

.practice-card.lesson-card-active:not(.lesson-card-selected):hover {
	--card-outline-color: rgba(0, 149, 236, 0.4);
	--card-outline-width: 8px;
}

.test-card.test-card-selected {
	--card-outline-color: #0274b6;
	--card-outline-width: 8px;
}

.test-card.test-card-completed.test-card-selected {
	--card-outline-color: #4b4b4b;
}

.test-card.test-card-active:not(.test-card-selected):hover {
	--card-outline-color: rgba(0, 149, 236, 0.4);
	--card-outline-width: 8px;
}

.test-card.test-card-completed:not(.test-card-selected):hover {
	--card-outline-color: rgba(75, 75, 75, 0.5);
	--card-outline-width: 8px;
}

.homework-card.homework-card-selected {
	--card-outline-color: #0274b6;
	--card-outline-width: 8px;
}

.homework-card.homework-card-completed.homework-card-selected {
	--card-outline-color: #4b4b4b;
}

.homework-card.homework-card-submitted.homework-card-selected {
	--card-outline-color: #8a6500;
}

.homework-card.homework-card-late.homework-card-selected {
	--card-outline-color: #b05b5b;
}

.homework-card.homework-card-active:not(.homework-card-selected):hover {
	--card-outline-color: rgba(0, 149, 236, 0.4);
	--card-outline-width: 8px;
}

.homework-card.homework-card-completed:not(.homework-card-selected):hover {
	--card-outline-color: rgba(75, 75, 75, 0.5);
	--card-outline-width: 8px;
}

.homework-card.homework-card-submitted:not(.homework-card-selected):hover {
	--card-outline-color: rgba(184, 135, 0, 0.5);
	--card-outline-width: 8px;
}

.homework-card.homework-card-late:not(.homework-card-selected):hover {
	--card-outline-color: rgba(176, 91, 91, 0.5);
	--card-outline-width: 8px;
}

/* Внутренний элемент для отображения border (радио-кнопка) */
.card-border-x3 {
	display: none;
}

/* Внутренний элемент для отображения border (радио-кнопка) */
.card-border-x1 {
	display: none;
}

.card-border-x2 {
	display: none;
}

.x1-11.lesson-card-selected .card-border-x1,
.x1-11.lesson-card-inactive.lesson-card-selected .card-border-x1,
.x1-11.lesson-card-active.lesson-card-selected .card-border-x1,
.x2-6.lesson-card-selected .card-border-x2,
.x2-6.lesson-card-inactive.lesson-card-selected .card-border-x2,
.x2-6.lesson-card-active.lesson-card-selected .card-border-x2 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

/* Фоновый прямоугольник с градиентом */
.rectangle-81-40 {
	background-color: #0095eccc;
	border-radius: 12px;
	height: 92px;
	left: 12px;
	position: absolute;
	top: -1px;
	width: 302px;
}

.card-bor-x4 {
	display: none;
}

/* Неактивное состояние для карточки 3 - прозрачная рамка */
.link:not(.practice-card).lesson-card-inactive .card-bor-x4 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние для карточки 3 (голубая карточка) */
.link:not(.practice-card).lesson-card-active .card-bor-x4 {
	border-color: #0274b6;
	border-width: 8px;
}

/* Hover для карточки 3 - полупрозрачная рамка */
.link:not(.practice-card):not(.lesson-card-active):hover .card-bor-x4 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.card-bor-x5 {
	display: none;
}

/* Неактивное состояние для карточки 3 - прозрачная рамка */
.link.lesson-card-inactive .card-bor-x5 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние для карточки 3 (голубая карточка) */
.link.lesson-card-active .card-bor-x5 {
	border-color: #0274b6;
	border-width: 8px;
}

/* Hover для карточки 3 - полупрозрачная рамка */
.link:not(.lesson-card-active):hover .card-bor-x5 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.card-bor-x6 {
	display: none;
}

/* Неактивное состояние для карточки 3 - прозрачная рамка */
.link.lesson-card-inactive .card-bor-x6 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние для карточки 3 (голубая карточка) */
.link.lesson-card-active .card-bor-x6 {
	border-color: #0274b6;
	border-width: 8px;
}

/* Hover для карточки 3 - полупрозрачная рамка */
.link:not(.lesson-card-active):hover .card-bor-x6 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

/* Изображение урока */
.image-41 {
	height: 86px;
	left: 10px;
	position: absolute;
	top: 3px;
	width: 293px;
}

/* Контейнер для текста и иконки */
.view-423 {
	height: 72px;
	left: 25px;
	position: relative;
	top: 10px;
	width: 245px;
	z-index: 5;
}

.text-409 {
	color: #ffffff;
	font-family: 'Poppins', Helvetica;
	font-size: 12px;
	font-weight: 600;
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 54px;
}

/* Заголовок урока */
.x01-38 {
	color: #ffffff;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	left: 38px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 0;
	width: 203px;
}

/* Иконка play */
.vector-295 {
	height: 23.15%;
	left: 0;
	position: absolute;
	top: 6.94%;
	width: 10.2%;
}

/* ========================================
     СТИЛИ РАДИО-КНОПОК ДЛЯ КАРТОЧЕК УРОКОВ
     ======================================== */

/* Базовый стиль для всех карточек уроков */
.x1-11,
.x2-6,
.x3-21 {
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Примечание: Стили для .card-border-x1 и .card-border-x2 находятся в компонентах X1152.vue и X272.vue */
/* Здесь только стили для .x3-21, так как это локальный элемент Screen8.vue */

/* Неактивное состояние для карточки 3 - прозрачная рамка */
.x3-21.lesson-card-inactive .card-border-x3 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние для карточки 3 (голубая карточка) */
.x3-21.lesson-card-active .card-border-x3 {
	border-color: transparent;
	border-width: 8px;
}

.x3-21.lesson-card-selected .card-border-x3 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

.x3-21.lesson-card-active.lesson-card-selected .card-border-x3 {
	border-color: #0274b6 !important;
}

.x3-21.lesson-card-completed.lesson-card-selected .card-border-x3 {
	border-color: #4b4b4b !important;
}

/* Hover для карточки 3 - полупрозрачная рамка */
.x3-21:not(.lesson-card-active):hover .card-border-x3 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.x3-21 .view-191 {
	right: 6px;
	top: 6px;
	left: auto;
	width: 20px;
	height: 20px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 11;
}

.x3-21 .vector-4-1 {
	width: 11px;
	height: 10px;
	margin: 0;
}

/* ======================================== */

.x4-6 {
	background-color: var(--storm-dust-2);
	border-radius: 12px;
	height: 90px;
	margin-left: 5px;
	margin-top: 8px;
	position: relative;
	width: 300px;
}

.view-424,
.image-42,
.image-43,
.image-45,
.image-46,
.image-47,
.image-48 {
	height: 86px;
	left: 4px;
	position: absolute;
	top: 3px;
	width: 293px;
}

.ellipse-146 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 45px;
	position: absolute;
	top: 66px;
	width: 20px;
}

.ellipse-143 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 24px;
	position: absolute;
	top: 33px;
	width: 20px;
}

.ellipse-144 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 0;
	position: absolute;
	top: 66px;
	width: 20px;
}

.rectangle-215 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 0;
	position: absolute;
	top: 33px;
	width: 21px;
}

.rectangle-214 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 0;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-216 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 23px;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-219 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 46px;
	position: absolute;
	top: 33px;
	width: 21px;
}

.rectangle-220 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 46px;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-221 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 22px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.ellipse-158 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 272px;
	position: absolute;
	top: 66px;
	width: 20px;
}

.rectangle-240 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 272px;
	position: absolute;
	top: 33px;
	width: 21px;
}

.rectangle-241 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 272px;
	position: absolute;
	top: 0;
	width: 21px;
}

.ellipse-153 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 250px;
	position: absolute;
	top: 0;
	width: 20px;
}

.ellipse-154 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 227px;
	position: absolute;
	top: 33px;
	width: 20px;
}

.ellipse-155 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 205px;
	position: absolute;
	top: 0;
	width: 20px;
}

.rectangle-234 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 204px;
	position: absolute;
	top: 22px;
	width: 21px;
}

.rectangle-235 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 203px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-236 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 226px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-237 {
	background-color: var(--white-4);
	border-radius: 20px;
	cursor: pointer;
	height: 31px;
	left: 249px;
	position: absolute;
	top: 22px;
	width: 21px;
}

.rectangle-238 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 249px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-239 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 227px;
	position: absolute;
	top: 0;
	width: 21px;
}

.ellipse-150 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 181px;
	position: absolute;
	top: 66px;
	width: 20px;
}

.ellipse-151 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 159px;
	position: absolute;
	top: 33px;
	width: 20px;
}

.ellipse-152 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 136px;
	position: absolute;
	top: 66px;
	width: 20px;
}

.rectangle-228 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 137px;
	position: absolute;
	top: 33px;
	width: 21px;
}

.rectangle-229 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 136px;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-230 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 159px;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-231 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 182px;
	position: absolute;
	top: 33px;
	width: 21px;
}

.rectangle-232 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 182px;
	position: absolute;
	top: 0;
	width: 21px;
}

.rectangle-233 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 158px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.ellipse-147 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 114px;
	position: absolute;
	top: 0;
	width: 20px;
}

.ellipse-148 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 91px;
	position: absolute;
	top: 33px;
	width: 20px;
}

.ellipse-149 {
	aspect-ratio: 1;
	background-color: var(--white-4);
	border-radius: 10px;
	height: 20px;
	left: 69px;
	position: absolute;
	top: 0;
	width: 20px;
}

.rectangle-222 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 69px;
	position: absolute;
	top: 22px;
	width: 21px;
}

.rectangle-223 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 67px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-224 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 90px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-225 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 114px;
	position: absolute;
	top: 22px;
	width: 21px;
}

.rectangle-226 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 113px;
	position: absolute;
	top: 55px;
	width: 21px;
}

.rectangle-227 {
	background-color: var(--white-4);
	border-radius: 20px;
	height: 31px;
	left: 91px;
	position: absolute;
	top: 0;
	width: 21px;
}

.view-container-3 {
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	margin-left: 25px;
	margin-top: 1px;
	min-height: 1077px;
	width: 300px;
}

.view-425 {
	height: 340px;
	position: absolute;
	width: 300px;
	transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-426 {
	display: flex;
	flex-direction: column;
	gap: 12px;
	height: auto;
	left: 0;
	position: absolute;
	top: 40px;
	width: 300px;
}

.practice-card.lesson-card-inactive {
	background-color: var(--storm-dust);
	background-image: none;
}

/* Пройденная практика - тёмно-серый фон как у уроков */
.practice-card.practice-card-completed {
	background-color: var(--storm-dust);
	background-image: none;
}

/* Бордер для выбранной пройденной практики - тёмно-серый */
.practice-card.practice-card-completed.lesson-card-selected .card-bor-x4 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

/* Галочка для практики - позиционирование как у уроков (правый верхний угол) */
.practice-card .view-191 {
	left: auto;
	right: 6px;
	top: 6px;
	width: 20px;
	height: 20px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 11;
}

.practice-card .vector-4-1 {
	width: 11px;
	height: 10px;
	margin: 0;
}

.practice-card.lesson-card-active .recT44 {
	border-radius: 12px;
	height: 92px;
	left: -1.5px;
	position: absolute;
	top: -1px;
	width: 301px;
}

.practice-card.practice-card-completed .recT44 {
	border-radius: 12px;
	height: 92px;
	left: -1.5px;
	position: absolute;
	top: -1px;
	width: 301px;
}

/* Скрываем галочку для непройденных практик */
.practice-card.lesson-card-inactive .view-191,
.practice-card.lesson-card-active .view-191,
.practice-card.lesson-card-locked .view-191 {
	display: none;
}

/* Показываем галочку для пройденных практик */
.practice-card.practice-card-completed .view-191 {
	display: flex;
}

/* Бордер для выбранной текущей (синей) практики - тёмно-синий */
.practice-card.lesson-card-active.lesson-card-selected .card-bor-x4 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px !important;
}

.link {
	background-color: var(--azure-radiance-2);
	border-radius: 12px;
	cursor: pointer;
	height: 90px;
	position: relative;
	transition: all 0.3s ease;
}

.view-427 {
	align-items: center;
	display: flex;
	gap: 5px;
	height: 48px;
	left: 14px;
	position: absolute;
	top: calc(50% - 24px);
	width: 261px;
}

.view-402-1 .homework-card .x01-39 {
	display: -webkit-box;
	flex: 1 1 auto;
	min-width: 0;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	white-space: normal !important;
	overflow: hidden;
	text-overflow: ellipsis;
	overflow-wrap: break-word;
	word-break: normal;
	line-height: 1.25;
}

.view-426 .x01-39 {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal !important;
	line-height: 1.25;
	margin: 0;
}

.view-402-1 .homework-card-content {
	align-items: flex-start !important;
}

.view-402-1 .homework-card .text-395 {
	align-self: flex-start;
	margin-top: 2px !important;
}

.view-402-1 .homework-card-title {
	display: -webkit-box;
	flex: 1 1 auto;
	min-width: 0;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	white-space: normal !important;
	overflow: hidden;
	text-overflow: ellipsis;
	overflow-wrap: break-word;
	word-break: normal;
	line-height: 1.25;
}

.text-395 {
	height: 23px;
	letter-spacing: 0;
	line-height: normal;
	margin-top: -21px;
	white-space: nowrap;
	width: 23px;
}

/* .x01-39 {
	height: 48px;
	letter-spacing: 0;
	line-height: normal;
	width: 229px;
} */

.x2-14 {
	background-color: var(--storm-dust-2);
	border-radius: 12px;
	height: 90px;
	margin-top: 12px;
	position: relative;
}

.view-428 {
	display: flex;
	gap: 5px;
	height: 48px;
	left: 14px;
	position: absolute;
	top: 21px;
	width: 278px;
}

.text-394 {
	align-self: center;
	height: 23px;
	letter-spacing: 0;
	line-height: normal;
	margin-top: -21px;
	white-space: nowrap;
	width: 23px;
}

.x01-40 {
	height: 48px;
	letter-spacing: 0;
	line-height: normal;
	width: 246px;
}

.x3-22 {
	background-color: var(--storm-dust-2);
	border-radius: 12px;
	height: 90px;
	margin-top: 13px;
	position: relative;
}

.image-44 {
	height: 86px;
	left: 4px;
	position: absolute;
	top: 2px;
	width: 293px;
}

.view-429 {
	display: flex;
	gap: 5px;
	height: 48px;
	left: 14px;
	position: absolute;
	top: 22px;
	width: 286px;
}

.text-393 {
	align-self: center;
	height: 23px;
	letter-spacing: 0;
	line-height: normal;
	margin-top: -23px;
	white-space: nowrap;
	width: 23px;
}

.x01-41,
.x01-45 {
	height: 48px;
	letter-spacing: 0;
	line-height: normal;
	width: 254px;
}

.view-430 {
	height: 30px;
	left: 2px;
	position: absolute;
	top: calc(50% - 170px);
	width: 177px;
	margin-bottom: 10px;
}

.text-396 {
	left: 150px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	white-space: nowrap;
	/* Используем flexbox для центрирования SVG внутри контейнера */
	display: flex;
	align-items: center;
	justify-content: center;
	/* Устанавливаем центр вращения */
	transform-origin: center center;
	transform: rotate(90deg);
	/* Выравниваем по высоте текста */
	top: 50%;
	margin-top: -6.3px; /* Половина высоты SVG (13px / 2) */
}

.text-396 :deep(svg) {
	display: block;
}

.text-3-4 {
	left: 38px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 0;
}

.view-431 {
	height: 339px;
	position: absolute;
	width: 300px;
	transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-402 {
	display: flex;
	flex-direction: column;
	gap: 12px;
	height: 294px;
	left: 0;
	position: absolute;
	top: 15px;
	width: 300px;
}

.view-402-1 {
	display: flex;
	flex-direction: column;
	gap: 12px;
	height: auto;
	left: 0;
	position: absolute;
	top: 15px;
	width: 300px;
}

.view-402-1 > .homework-card {
	flex-shrink: 0;
}

.view-432 {
	height: 72px;
	left: 24px;
	position: absolute;
	top: 10px;
	width: 246px;
}

.text-390 {
	left: 1px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 54px;
}

.x01-42 {
	left: 39px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 0;
	width: 203px;
}

.vector-301 {
	height: 29.3%;
	left: 0;
	position: absolute;
	top: 5.56%;
	width: 10.16%;
}

.view-433 {
	height: 30px;
	left: 2px;
	position: absolute;
	top: -30px;
	width: 135px;
}

.text-391 {
	left: 114px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	white-space: nowrap;
	/* Используем flexbox для центрирования SVG внутри контейнера */
	display: flex;
	align-items: center;
	justify-content: center;
	/* Устанавливаем центр вращения */
	transform-origin: center center;
	transform: rotate(90deg);
	/* Выравниваем по высоте текста */
	top: 50%;
	margin-top: -6px; /* Половина высоты SVG (13px / 2) */
}

.view-434 {
	height: 339px;
	position: absolute;
	width: 300px;
	transition: top 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-403 {
	display: flex;
	gap: 8px;
	height: 48px;
	left: 14px;
	position: absolute;
	top: 18px;
	width: 285px;
}

.text-38-1 {
	height: 23px;
	letter-spacing: 0;
	line-height: normal;
	margin-top: 4.5px;
	white-space: nowrap;
	width: 23px;
}

.x01-43,
.x01-44 {
	height: 48px;
	letter-spacing: 0;
	line-height: normal;
	width: 250px;
}

.view-402-item {
	background-color: var(--storm-dust-2);
	border-radius: 12px;
	height: 90px;
	position: relative;
}

.view-435 {
	display: flex;
	gap: 8px;
	height: 48px;
	left: 14px;
	position: absolute;
	top: 18px;
	width: 289px;
}

.view-436 {
	height: 30px;
	left: 2px;
	position: absolute;
	top: -30px;
	width: 274px;
}

.text-386 {
	left: 254px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	white-space: nowrap;
	/* Используем flexbox для центрирования SVG внутри контейнера */
	display: flex;
	align-items: center;
	justify-content: center;
	/* Устанавливаем центр вращения */
	transform-origin: center center;
	transform: rotate(90deg);
	/* Выравниваем по высоте текста */
	top: 50%;
	margin-top: -6px; /* Половина высоты SVG (13px / 2) */
}

.collapsible-block {
	overflow: visible;
}

/* Кликабельный заголовок для блока "Уроки" (View712) */
.clickable-header {
	cursor: pointer;
	transition: opacity 0.3s ease;
	user-select: none;
}

.clickable-header:hover {
	opacity: 0.8;
}

.clickable-header:active {
	transform: scale(0.98);
}

/* Кликабельные заголовки для остальных блоков */
.block-header-clickable {
	cursor: pointer;
	transition: opacity 0.3s ease;
	user-select: none;
}

.block-header-clickable:hover {
	opacity: 0.8;
}

/* Иконка стрелки в заголовке */
/* Улучшенная анимация: 0.4s с Material Design easing */
.clickable-header .text-256,
.block-header-clickable .text-396,
.block-header-clickable .text-391,
.block-header-clickable .text-386 {
	transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Поворот стрелки при сворачивании */
.clickable-header.collapsed .text-256,
.block-header-clickable.collapsed .text-396,
.block-header-clickable.collapsed .text-391,
.block-header-clickable.collapsed .text-386 {
	transform: rotate(0deg) !important;
}

/* Класс для поворота иконки на 180 градусов (альтернативный подход) */
.icon.rotated {
	transform: rotate(180deg);
}

/* Анимация сворачивания/разворачивания */
/* Улучшенная анимация: 0.4s с Material Design easing */
.collapse-enter-active,
.collapse-leave-active {
	transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
		opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
	opacity: 0;
}

.collapse-enter-to,
.collapse-leave-from {
	opacity: 1;
}

.lesson-card-locked {
	opacity: 0.6;
	pointer-events: none;
	cursor: default;
}

.practice-card.lesson-card-locked {
	background-image: none;
}

.lesson-card-inactive .view-191,
.lesson-card-locked .view-191 {
	display: none;
}

.lesson-icon-article svg {
	width: 100%;
	height: 100%;
	display: block;
}

/* Hover для пройденных уроков - светло-серая рамка */
.x1-11.lesson-card-inactive:not(.lesson-card-selected):hover .card-border-x1,
.x2-6.lesson-card-inactive:not(.lesson-card-selected):hover .card-border-x2,
.x3-21.lesson-card-inactive:not(.lesson-card-selected):hover .card-border-x3 {
	border-color: rgba(75, 75, 75, 0.5);
	border-width: 8px;
}

/* Hover для активных (текущих) уроков - синяя рамка */
.x1-11.lesson-card-active:not(.lesson-card-selected):hover .card-border-x1,
.x2-6.lesson-card-active:not(.lesson-card-selected):hover .card-border-x2 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.x3-21.lesson-card-active:not(.lesson-card-selected):hover .card-border-x3 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.view-420
	.x1-11.lesson-card-inactive:not(.lesson-card-selected):hover
	.card-border-x1,
.view-420
	.x2-6.lesson-card-inactive:not(.lesson-card-selected):hover
	.card-border-x2,
.view-420
	.x3-21.lesson-card-inactive:not(.lesson-card-selected):hover
	.card-border-x3 {
	border-color: rgba(75, 75, 75, 0.5) !important;
	border-width: 8px !important;
}

.view-420
	.x1-11.lesson-card-active:not(.lesson-card-selected):hover
	.card-border-x1,
.view-420
	.x2-6.lesson-card-active:not(.lesson-card-selected):hover
	.card-border-x2 {
	border-color: rgba(0, 149, 236, 0.4) !important;
	border-width: 8px !important;
}

.view-420
	.x3-21.lesson-card-active:not(.lesson-card-selected):hover
	.card-border-x3 {
	border-color: rgba(0, 149, 236, 0.4) !important;
	border-width: 8px !important;
}

.view-420
	.x1-11.lesson-card-completed:not(.lesson-card-selected):hover
	.card-border-x1,
.view-420
	.x2-6.lesson-card-completed:not(.lesson-card-selected):hover
	.card-border-x2,
.view-420
	.x3-21.lesson-card-completed:not(.lesson-card-selected):hover
	.card-border-x3 {
	border-color: rgba(75, 75, 75, 0.5) !important;
	border-width: 8px !important;
}

/* ===== ПРАКТИКА ===== */

/* Hover для пройденной практики - светло-серая рамка */
.practice-card.practice-card-completed:not(.lesson-card-selected):hover
	.card-bor-x4 {
	border-color: rgba(75, 75, 75, 0.5);
	border-width: 8px;
}

/* Hover для активной (текущей) практики - синяя рамка */
.practice-card.lesson-card-active:not(.lesson-card-selected):hover
	.card-bor-x4 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

.view-402 {
	animation: fadeIn 0.4s linear;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.x533,
.x6 {
	transition: all 0.2s ease;
}

.x533:hover,
.x6:hover {
	transform: translateX(5px);
	opacity: 0.8;
}

/* Плавная анимация для иконок */
.text-256,
.text-396,
.text-391,
.text-386 {
	display: inline-block;
}

.block-header-clickable:active {
	transform: scale(0.98);
}

/* ========================================
     ПАТТЕРН ДЛЯ КАРТОЧЕК (тематические иконки)
     ======================================== */

/* SVG паттерн с книгами, шестерёнками, карандашами - много фигурок в разных положениях */
:root {
	--card-pattern: url("data:image/svg+xml,%3Csvg width='200' height='90' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='eduPattern' patternUnits='userSpaceOnUse' width='200' height='90'%3E%3C!-- Книга 1 --%3E%3Cg transform='translate(8,12) rotate(15)'%3E%3Cpath d='M0 0h10v13h-10zM5 1v11M5 1L2 2.5v8L5 12M5 1l3 1.5v8L5 12' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.3'/%3E%3C/g%3E%3C!-- Шестерёнка 1 --%3E%3Cg transform='translate(45,30) rotate(-20)'%3E%3Ccircle r='7' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.3'/%3E%3Ccircle r='3' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3Cpath d='M0-9v2m0 14v2m-9-9h2m14 0h2m-4-7l-1.5 1.5m-7 7l-1.5 1.5m10 0l-1.5-1.5m-7-7l-1.5-1.5' stroke='rgba(255,255,255,0.20)' stroke-width='1.5'/%3E%3C/g%3E%3C!-- Карандаш 1 --%3E%3Cg transform='translate(80,60) rotate(40)'%3E%3Cpath d='M0 0l12 0 0 4-12 0zM12 0l3 2-3 2z' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.3'/%3E%3C/g%3E%3C!-- Лампочка 1 --%3E%3Cg transform='translate(110,18) rotate(10)'%3E%3Ccircle r='6' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.2'/%3E%3Cpath d='M-2.5 8h5M-1.5 10h3M0 6v5' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3C/g%3E%3C!-- Галочка 1 --%3E%3Cg transform='translate(145,45) rotate(-15)'%3E%3Cpath d='M0 4l4 4 9-11' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C!-- Книга 2 --%3E%3Cg transform='translate(175,70) rotate(-30)'%3E%3Cpath d='M0 0h9v12h-9zM4.5 1v10M4.5 1L2 2.3v7.4L4.5 11M4.5 1l2.5 1.3v7.4L4.5 11' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.2'/%3E%3C/g%3E%3C!-- Шестерёнка 2 --%3E%3Cg transform='translate(30,65) rotate(25)'%3E%3Ccircle r='5' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3Ccircle r='2' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='0.8'/%3E%3Cpath d='M0-7v2m0 10v2m-7-7h2m10 0h2' stroke='rgba(255,255,255,0.20)' stroke-width='1.2'/%3E%3C/g%3E%3C!-- Звезда --%3E%3Cg transform='translate(130,70) rotate(20)'%3E%3Cpath d='M0-7l1.8 5.5h5.8l-4.7 3.4 1.8 5.5-4.7-3.4-4.7 3.4 1.8-5.5-4.7-3.4h5.8z' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3C/g%3E%3C!-- Документ --%3E%3Cg transform='translate(70,15) rotate(-12)'%3E%3Cpath d='M0 0h9v12h-9zM1.5 3h6M1.5 5.5h6M1.5 8h4' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3C/g%3E%3C!-- Карандаш 2 --%3E%3Cg transform='translate(165,25) rotate(-50)'%3E%3Cpath d='M0 0l10 0 0 3.5-10 0zM10 0l2.5 1.75-2.5 1.75z' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.2'/%3E%3C/g%3E%3C!-- Лампочка 2 --%3E%3Cg transform='translate(100,42) rotate(-25)'%3E%3Ccircle r='5' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3Cpath d='M-2 6.5h4M-1 8h2' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='0.8'/%3E%3C/g%3E%3C!-- Галочка 2 --%3E%3Cg transform='translate(55,50) rotate(30)'%3E%3Cpath d='M0 3l3 3 7-8' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C!-- Шестерёнка 3 --%3E%3Cg transform='translate(185,48) rotate(45)'%3E%3Ccircle r='6' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3Ccircle r='2.5' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='0.8'/%3E%3C/g%3E%3C!-- Книга 3 --%3E%3Cg transform='translate(15,48) rotate(-18)'%3E%3Cpath d='M0 0h8v11h-8zM4 1v9M4 1L1.5 2v7L4 10M4 1l2.5 1v7L4 10' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='1'/%3E%3C/g%3E%3C!-- Звезда 2 --%3E%3Cg transform='translate(148,12) rotate(-35)'%3E%3Cpath d='M0-5l1.3 4h4.2l-3.4 2.5 1.3 4-3.4-2.5-3.4 2.5 1.3-4-3.4-2.5h4.2z' stroke='rgba(255,255,255,0.20)' fill='none' stroke-width='0.9'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23eduPattern)'/%3E%3C/svg%3E");
}

/* ===== КАРТОЧКИ УРОКОВ ===== */

/* Активный урок - голубой фон с паттерном */
.x3-21.lesson-card-active,
.x1-11.lesson-card-active,
.x2-6.lesson-card-active {
	background-color: #0095ec !important;
	background-image: var(--card-pattern) !important;
	border-radius: 12px;
}

.x3-21.lesson-card-active {
	margin-left: 0;
}

/* Завершённый урок - тёмно-серый фон с паттерном */
.x3-21.lesson-card-completed,
.x1-11.lesson-card-completed,
.x2-6.lesson-card-completed,
.x3-21.lesson-card-inactive,
.x1-11.lesson-card-inactive,
.x2-6.lesson-card-inactive {
	background-color: #636363 !important;
	background-image: var(--card-pattern) !important;
	border-radius: 12px;
}

/* Скрываем ВСЕ фоновые элементы от Anima для уроков */
.x3-21.lesson-card-active .image-41,
.x3-21.lesson-card-completed .image-41,
.x3-21.lesson-card-inactive .image-41,
.x1-11.lesson-card-active .image-13,
.x1-11.lesson-card-completed .image-13,
.x1-11.lesson-card-inactive .image-13,
.x2-6.lesson-card-active .image-15,
.x2-6.lesson-card-completed .image-15,
.x2-6.lesson-card-inactive .image-15 {
	display: none !important;
}

/* Убираем старый фон для активного урока */
.x3-21.lesson-card-active .rectangle-81-40,
.x3-21.lesson-card-completed .rectangle-81-40,
.x3-21.lesson-card-inactive .rectangle-81-40 {
	display: none !important;
}

/* Белый цвет текста и иконок для карточек уроков */
.x1-11.lesson-card-active .x01-17,
.x1-11.lesson-card-completed .x01-17,
.x1-11.lesson-card-inactive .x01-17,
.x2-6.lesson-card-active .x01-19,
.x2-6.lesson-card-completed .x01-19,
.x2-6.lesson-card-inactive .x01-19,
.x3-21.lesson-card-active .x01-38,
.x3-21.lesson-card-completed .x01-38,
.x3-21.lesson-card-inactive .x01-38 {
	color: #ffffff !important;
}

/* Белые иконки для карточек уроков */
.x1-11.lesson-card-active .text-255 svg path,
.x1-11.lesson-card-completed .text-255 svg path,
.x1-11.lesson-card-inactive .text-255 svg path {
	fill: #ffffff !important;
	fill-opacity: 1 !important;
}

.x2-6.lesson-card-active .vector-190,
.x2-6.lesson-card-completed .vector-190,
.x2-6.lesson-card-inactive .vector-190 {
	filter: brightness(0) invert(1) !important;
}

/* Переносы текста по правилам русского языка */
.x01-17,
.x01-19,
.x01-38,
.x01-39,
.x01-40,
.x01-41,
.x01-42,
.x01-43,
.x01-44,
.x01-45 {
	hyphens: auto !important;
	-webkit-hyphens: auto !important;
	-ms-hyphens: auto !important;
	word-wrap: break-word !important;
	overflow-wrap: break-word !important;
	word-break: normal !important;
	white-space: normal !important;
	max-width: 100% !important;
}

/* Атрибут lang для переносов - добавляем через CSS */
.x01-17::before,
.x01-19::before,
.x01-38::before,
.x01-39::before,
.x01-42::before,
.x01-43::before {
	content: '';
}

/* Мягкие переносы для русского текста */
.view-189,
.view-193,
.view-423,
.view-427,
.view-428,
.view-429,
.view-432,
.view-403,
.view-435 {
	word-break: normal;
	overflow-wrap: break-word;
	hyphens: auto;
	-webkit-hyphens: auto;
}

/* ===== КАРТОЧКИ ПРАКТИКИ ===== */

/* Активная практика - голубой фон с паттерном */
.practice-card.lesson-card-active {
	background-color: #0095ec !important;
	background-image: var(--card-pattern) !important;
}

/* Завершённая практика - тёмно-серый фон с паттерном */
.practice-card.practice-card-completed {
	background-color: #636363 !important;
	background-image: var(--card-pattern) !important;
}

/* Скрываем фоновую картинку от Anima для практики */
.practice-card.lesson-card-active .image-42,
.practice-card.practice-card-completed .image-42 {
	display: none !important;
}

/* ===== КАРТОЧКИ ТЕСТОВ ===== */

/* Базовый стиль карточки теста */
.test-card {
	position: relative;
	overflow: visible;
}

.final-test-badge {
	display: inline-flex;
	position: absolute;
	right: 10px;
	bottom: 8px;
	align-items: center;
	margin: 0;
	padding: 2px 8px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 600;
	color: #7c2d12;
	background: #ffedd5;
	border: 1px solid #fed7aa;
	white-space: nowrap;
}

/* Активный тест - голубой фон с паттерном */
.test-card.test-card-active {
	background-color: #0095ec !important;
	background-image: var(--card-pattern) !important;
}

/* Завершённый тест - тёмно-серый фон с паттерном */
.test-card.test-card-completed {
	background-color: #636363 !important;
	background-image: var(--card-pattern) !important;
}

/* Неактивный тест - без изменений */
.test-card.test-card-inactive {
	background-color: var(--storm-dust-2);
}

/* Заблокированный тест */
.test-card.test-card-locked {
	opacity: 0.6;
	pointer-events: none;
	cursor: default;
}

/* Выбранный тест - бордер */
.test-card.test-card-selected .card-bor-x5 {
	border-color: #0274b6 !important;
	border-width: 8px !important;
}

.test-card.test-card-completed.test-card-selected .card-bor-x5 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

/* Hover для активного теста */
.test-card.test-card-active:not(.test-card-selected):hover .card-bor-x5 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

/* Hover для завершённого теста */
.test-card.test-card-completed:not(.test-card-selected):hover .card-bor-x5 {
	border-color: rgba(75, 75, 75, 0.5);
	border-width: 8px;
}

/* Скрываем фоновую картинку от Anima */
.test-card .image-45 {
	display: none;
}

/* ===== КАРТОЧКИ ДОМАШНИХ ЗАДАНИЙ ===== */

/* Базовый стиль карточки ДЗ */
.homework-card {
	position: relative;
	overflow: visible;
}

/* Активное ДЗ - голубой фон с паттерном */
.homework-card.homework-card-active {
	background-color: #0095ec !important;
	background-image: var(--card-pattern) !important;
}

/* Завершённое ДЗ - тёмно-серый фон с паттерном */
.homework-card.homework-card-completed {
	background-color: #636363 !important;
	background-image: var(--card-pattern) !important;
}

.homework-card.homework-card-submitted {
	background-color: #b88700 !important;
	background-image: var(--card-pattern) !important;
}

.homework-card.homework-card-late {
	background-color: #e7a3a3 !important;
	background-image: var(--card-pattern) !important;
}

/* Неактивное ДЗ - без изменений */
.homework-card.homework-card-inactive {
	background-color: var(--storm-dust-2);
}

/* Заблокированное ДЗ */
.homework-card.homework-card-locked {
	opacity: 0.6;
	pointer-events: none;
	cursor: default;
}

/* Выбранное ДЗ - бордер */
.homework-card.homework-card-selected .card-bor-x6 {
	border-color: #0274b6 !important;
	border-width: 8px !important;
}

.homework-card.homework-card-completed.homework-card-selected .card-bor-x6 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

.homework-card.homework-card-submitted.homework-card-selected .card-bor-x6 {
	border-color: #8a6500 !important;
	border-width: 8px !important;
}

.homework-card.homework-card-late.homework-card-selected .card-bor-x6 {
	border-color: #b05b5b !important;
	border-width: 8px !important;
}

/* Hover для активного ДЗ */
.homework-card.homework-card-active:not(.homework-card-selected):hover
	.card-bor-x6 {
	border-color: rgba(0, 149, 236, 0.4);
	border-width: 8px;
}

/* Hover для завершённого ДЗ */
.homework-card.homework-card-completed:not(.homework-card-selected):hover
	.card-bor-x6 {
	border-color: rgba(75, 75, 75, 0.5);
	border-width: 8px;
}

.homework-card.homework-card-submitted:not(.homework-card-selected):hover
	.card-bor-x6 {
	border-color: rgba(184, 135, 0, 0.5);
	border-width: 8px;
}

.homework-card.homework-card-late:not(.homework-card-selected):hover
	.card-bor-x6 {
	border-color: rgba(176, 91, 91, 0.5);
	border-width: 8px;
}

/* Скрываем фоновую картинку от Anima */
.homework-card .image-46 {
	display: none;
}

/* ========================================
     ТИПОГРАФИКА - СТИЛИ ТЕКСТА
     ======================================== */

/* Белый текст 16px semi-bold (заголовки карточек) */
.x01-38,
.x01-39,
.x01-42,
.x01-43 {
	font-family: 'Poppins', sans-serif;
	font-size: 16px;
	color: #ffffff;
	line-height: normal;
	letter-spacing: 0;
}

/* Белый текст 12px semi-bold (подзаголовки/время) */
.text-409,
.text-390 {
	font-family: 'Poppins', Helvetica, Arial, sans-serif;
	font-size: 12px;
	font-weight: 600;
	color: #ffffff;
	line-height: normal;
	letter-spacing: 0;
}

/* Чёрный текст 20px semi-bold (заголовки блоков) */
.text-3-4 {
	font-family: 'Poppins', Helvetica, Arial, sans-serif;
	font-size: 20px;
	font-weight: 600;
	color: #000000;
	line-height: normal;
	letter-spacing: 0;
}

/* Иконки FontAwesome - чёрные 20px (стрелки в заголовках) */
.text-391,
.text-386 {
	font-family: 'Font Awesome 5 Free', sans-serif;
	font-size: 20px;
	font-weight: 900;
	color: #000000;
	line-height: normal;
}

/* Иконки FontAwesome - белые 20px (иконки в карточках) */
.text-38-1 {
	font-family: 'Font Awesome 5 Free', sans-serif;
	font-size: 20px;
	font-weight: 900;
	color: #ffffff;
	line-height: normal;
}
</style>

<style scoped>
@media (max-width: 1366px) {
	.view-420 {
		margin-left: 24px;
	}
}
  /* ========================================
     АДАПТИВНЫЕ СТИЛИ ДЛЯ ПЛАНШЕТОВ (до 1400px)
     ======================================== */
  @media (max-width: 1400px) {
    /* Основной контейнер сайдбара - добавляем отступы */
    .view-420 {
      padding: 0 12px;
      box-sizing: border-box;
    }
  
    /* Блоки контента - растягиваем на всю ширину */
    .view-421,
    .view-425,
    .view-431,
    .view-434 {
      width: 100%;
      margin-left: 0;
      left: 0;
    }
  
    /* Контейнер карточек уроков */
    .view-422 {
      width: 100%;
      left: 0;
    }
  
    /* Все карточки (уроки, практика и т.д.) - на всю ширину */
    .view-422 .x1-11,
    .view-422 .x2-6,
    .view-422 .x3-21,
    .view-422 .x4-6,
    .view-422 .x533,
    .view-422 .x6 {
      width: 100%;
    }
  
    /* Рамки карточек - адаптируем под новую ширину */
    .card-border-x3,
    .card-border-x1,
    .card-border-x2,
    .card-bor-x4 {
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
    }
  }
  
  /* ========================================
     АДАПТИВНЫЕ СТИЛИ ДЛЯ МОБИЛЬНЫХ (до 768px)
     ======================================== */
  @media (max-width: 768px) {
    /* Сайдбар - фиксированная позиция, выдвижное меню */
    .view-420 {
      position: fixed;
      top: 0;
      bottom: 0;
      left: var(--sidebar-left-offset, 0px);
      width: var(--sidebar-left-width);
      max-width: 320px;
      height: auto;
      min-height: 100dvh; /* dvh - динамическая высота viewport для мобильных */
      min-width: var(--sidebar-left-width);
      padding: calc(var(--header-height) + max(0px, env(safe-area-inset-top)) + 12px) 12px 24px;
      scroll-padding-top: calc(var(--header-height) + max(0px, env(safe-area-inset-top)) + 12px);
      background: #ffffff;
      border-radius: 0;
      box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
      z-index: 2000;
      overflow-y: auto;
      overflow-x: hidden;
    }
  
    /* Открытое состояние сайдбара */
    .view-420.is-open {
      transform: translateX(0);
    }
  
    /* Сворачиваемые блоки - относительное позиционирование */
    .collapsible-block {
      position: relative;
      top: 0 !important;
      margin-top: 12px;
    }

    /* Когда в сайдбаре остаётся только блок ДЗ (view-434), добавляем
       дополнительный верхний зазор, чтобы карточка не заходила под кнопку "Вернуться назад". */
    .view-container-3 > .collapsible-block:first-child {
      margin-top: 20px;
    }
  
    /* Контейнеры блоков - убираем абсолютное позиционирование */
    .view-421,
    .view-425,
    .view-431,
    .view-434 {
      position: relative;
      height: auto;
    }
  
    /* Контейнер карточек уроков */
    .view-422 {
      position: relative;
      top: 0;
    }
  }
  
  /* ========================================
     ДЕТАЛЬНАЯ АДАПТАЦИЯ ДЛЯ МОБИЛЬНЫХ
     ======================================== */
  @media (max-width: 768px) {
    /* Основной контейнер - на всю ширину */
    .view-container-3 {
      width: 100%;
      margin: 0;
      min-height: auto;
      gap: 12px;
    }
  
    /* Сворачиваемый блок - карточка с тенью */
    .collapsible-block {
      background: #ffffff;
      border-radius: 14px;
      padding: 8px;
      box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
    }
  
    /* Контейнеры разделов - автоматическая высота */
    .view-421,
    .view-425,
    .view-431,
    .view-434 {
      height: auto;
    }
  
    /* Списки карточек - относительное позиционирование */
    .view-422,
    .view-426,
    .view-402,
    .view-402-1 {
      position: relative;
      top: 0;
      width: 100%;
      gap: 12px;
    }
  
    /* Заголовки блоков (Уроки, Практика, Тесты, ДЗ) */
    .view-430,
    .view-433,
    .view-436 {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 10px;
      border-radius: 10px;
      background: #eef3f8;
      margin-bottom: 8px;
    }
  
    /* Стрелки раскрытия в заголовках */
    .text-396,
    .text-391,
    .text-386 {
      position: static;
      transform: none;
      order: 3;
      margin-left: auto;
      margin-top: 0;
      font-size: 14px;
      width: 18px;
      height: 18px;
    }
  
    /* Текст заголовков блоков */
    .text-3-4 {
      position: static;
      order: 2;
      flex: 1;
      font-size: 14px;
      line-height: 1.2;
    }
  
    /* ===== КАРТОЧКИ УРОКОВ/ПРАКТИКИ/ТЕСТОВ/ДЗ ===== */
    
    /* Все типы карточек - адаптивная высота */
    :deep(.x1-11),
    :deep(.x2-6),
    :deep(.x3-21),
    :deep(.x5-2),
    :deep(.view-185-item-1-1),
    :deep(.view-402-item-1),
    :deep(.link),
    :deep(.x2-14),
    :deep(.x3-22),
    :deep(.view-402-item) {
      width: 100%;
      min-height: 64px;
      height: auto !important;
      margin: 0;
      border-radius: 12px;
      overflow: hidden;
    }
  
    /* Фоновые изображения карточек - на всю карточку */
    :deep(.image-13),
    :deep(.image-15),
    :deep(.image-18),
    :deep(.image-20),
    :deep(.image-41),
    :deep(.image-42),
    :deep(.image-43),
    :deep(.image-44),
    :deep(.image-45),
    :deep(.image-46),
    :deep(.image-47),
    :deep(.image-48),
    :deep(.image-49) {
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: brightness(0.85); /* Затемнение для читаемости текста */
    }
  
    /* ===== КАРТОЧКИ УРОКОВ (типы 1, 2) ===== */
    
    /* Контейнер содержимого карточки - сетка с иконкой и текстом */
    :deep(.view-189),
    :deep(.view-193),
    :deep(.view-195),
    :deep(.view-197) {
      position: relative;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      display: grid;
      grid-template-columns: 24px 1fr;
      align-items: center;
      gap: 6px;
      padding: 8px 30px 8px 10px;
      box-sizing: border-box;
      z-index: 2;
    }
  
    /* Иконки уроков (play, документ и т.д.) */
    :deep(.text-255),
    :deep(.vector-190),
    :deep(.vector-196),
    :deep(.text-24-3) {
      position: static;
      width: 20px;
      height: 20px;
    }
  
    /* Заголовки карточек уроков */
    :deep(.x01-17),
    :deep(.x01-19),
    :deep(.x01-22),
    :deep(.x01-28) {
      position: static;
      width: 100%;
      white-space: normal;
      line-height: 1.3;
      font-size: 13px;
    }
  
    /* Галочка "выполнено" - в правом верхнем углу */
    :deep(.view-189 .view-191),
    :deep(.view-193 .view-191),
    :deep(.link .view-191) {
      position: absolute;
      right: 10px;
      top: 10px;
      left: auto;
    }
  
    /* ===== КАРТОЧКИ УРОКОВ (тип 3 - видео) ===== */
    
    /* Контейнер с иконкой, заголовком и временем - сетка 2x2 */
    :deep(.view-423),
    :deep(.view-432),
    :deep(.view-442) {
      position: relative;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      display: grid;
      grid-template-columns: 24px 1fr;
      grid-template-rows: auto auto;
      gap: 2px 8px;
      padding: 8px 10px;
      box-sizing: border-box;
      z-index: 2;
    }
  
    /* Иконки play/статьи - занимают 2 строки */
    :deep(.vector-295),
    :deep(.lesson-icon-article),
    :deep(.vector-301),
    :deep(.vector-311) {
      position: static;
      width: 18px;
      height: 18px;
      grid-column: 1;
      grid-row: 1 / span 2;
    }
  
    /* Центрирование SVG иконки */
    :deep(.lesson-icon-article) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  
    /* Заголовок урока - первая строка, вторая колонка */
    :deep(.x01-38),
    :deep(.x01-42),
    :deep(.x01-46) {
      position: static;
      width: 100%;
      white-space: normal;
      grid-column: 2;
      grid-row: 1;
      line-height: 1.3;
    }
  
    :deep(.text-409),
    :deep(.text-390),
    :deep(.text-38-2) {
      position: static;
      width: 100%;
      font-size: 11px;
      opacity: 0.75;
      grid-column: 2;
      grid-row: 2;
      margin: 0;
    }
  
    /* ===== КАРТОЧКИ ПРАКТИКИ/ТЕСТОВ/ДЗ ===== */
    
    /* Контейнер содержимого - flexbox с иконкой и текстом */
    :deep(.view-427),
    :deep(.view-428),
    :deep(.view-429),
    :deep(.view-403),
    :deep(.view-435) {
      position: relative;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 10px;
      box-sizing: border-box;
      z-index: 2;
    }

    /* Иконки (номера, символы) */
    :deep(.text-395),
    :deep(.text-394),
    :deep(.text-393),
    :deep(.text-38-1) {
      position: static;
      width: auto;
      height: auto;
      margin: 0;
      white-space: normal;
    }
  
    /* Заголовки карточек практики/тестов/ДЗ */
    :deep(.x01-39),
    :deep(.x01-40),
    :deep(.x01-41),
    :deep(.x01-43),
    :deep(.x01-44),
    :deep(.x01-45) {
      position: static;
      width: 100%;
      white-space: normal;
      line-height: 1.3;
      font-size: 13px;
    }

    :deep(.view-402-1 .view-427) {
      align-items: flex-start;
      height: auto;
    }

    :deep(.view-402-1 .x01-39) {
      display: -webkit-box;
      flex: 1 1 auto;
      min-width: 0;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal !important;
      overflow: hidden;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
      word-break: normal;
      line-height: 1.25;
    }

    :deep(.view-402-1 .homework-card-content) {
      align-items: flex-start;
    }

    :deep(.view-402-1 .text-395) {
      align-self: flex-start;
      margin-top: 2px !important;
    }

    :deep(.view-402-1 .homework-card-title) {
      display: -webkit-box;
      flex: 1 1 auto;
      min-width: 0;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal !important;
      overflow: hidden;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
      word-break: normal;
      line-height: 1.25;
    }

    :deep(.view-402-1 .homework-card) {
      min-height: 64px !important;
      height: auto !important;
    }

  
    /* ===== ОБЩИЕ ЭЛЕМЕНТЫ ===== */
    
    /* Галочка "выполнено" - уменьшенный размер */
    :deep(.view-191) {
      height: 18px;
      width: 18px;
    }
  
    /* Рамки выделения карточек - тоньше для мобильных */
    :deep(.card-border-x1),
    :deep(.card-border-x2),
    :deep(.card-border-x3),
    :deep(.card-bor-x4),
    :deep(.card-bor-x5),
    :deep(.card-bor-x6) {
      inset: -3px;
      width: auto;
      height: auto;
      border-width: 4px;
      border-radius: 16px;
    }

  
    /* Фоновый оверлей для пройденных карточек */
    :deep(.recT44) {
      inset: 0;
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  
    /* Иконки домашних заданий (writing, task, drawing) */
    :deep(.writing),
    :deep(.task-2),
    :deep(.drawing) {
      position: static;
      order: 1;
      width: 18px;
      height: 18px;
      flex: 0 0 18px;
    }
  }

@media (min-width: 1500px) and (max-width: 1600px) and (max-height: 920px) {
	.view-420 {
		box-sizing: border-box;
		padding-right: 8px;
	}

	.view-421,
	.view-425,
	.view-431,
	.view-434 {
		width: 300px;
		left: 0;
		margin-left: 12px;
	}

	.view-422,
	.view-426,
	.view-402,
	.view-402-1 {
		width: 300px;
		left: 0;
		gap: 10px;
	}

	.x01-38,
	.x01-39,
	.x01-42,
	.x01-43 {
		font-size: 15px;
		line-height: 1.25;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.view-423,
	.view-432,
	.view-427 {
		overflow: hidden;
	}

	.x3-21,
	.practice-card,
	.test-card,
	.homework-card {
		margin-top: 6px;
	}
}

  /* ===== АДАПТИВНОЕ МАСШТАБИРОВАНИЕ ПОД РАЗНЫЕ РАЗРЕШЕНИЯ И МАСШТАБЫ БРАУЗЕРА ===== */
/* Дизайн создан для 1920px, поэтому нужно масштабирование для меньших разрешений */

/* Экраны ≤1366px (реальные мониторы 1366×768) */
@media (max-width: 1366px) {
	body {
		zoom: 0.711; /* 1366 ÷ 1920 = 0.711 */
	}

}

/* Экраны 1367-1600px (включает FullHD с масштабом 125%: 1920÷1.25=1536px) */
@media (min-width: 1367px) and (max-width: 1600px) {
	body {
		zoom: 0.85; /* Компромисс между 0.711 и 1.0 для промежуточных разрешений */
	}
}

/* QHD 2560x1440 (15.6") — компенсация под 100% масштаб (как при 90%) */
/* При масштабе Windows 150% браузер видит ~1707px (2560/1.5) */
@media (min-width: 1601px) and (max-width: 1800px) {
	body {
		zoom: 0.9 !important;
	}
}

/* Экраны 1801-2300px - без дополнительного масштабирования */
@media (min-width: 1801px) and (max-width: 2300px) {
	body {
		zoom: 1.0 !important;
	}
}

/* QHD 2560x1440 с масштабом Windows 100% - увеличение до 150% */
/* При масштабе Windows 100% браузер видит полные 2560px */
@media (min-width: 2301px) and (max-width: 2880px) {
	body {
		zoom: 1.35 !important;
	}
}

  </style>
